import type {Placement} from '@floating-ui/core';
import type {ComputeConfig} from 'svelte-floating-ui';
import {flip, offset} from 'svelte-floating-ui/dom';

export function floatingUiCommonSettings(placement: Placement, offsetInPx = 10): ComputeConfig {
    return {
        placement,
        strategy: 'fixed',
        middleware: [
            offset(offsetInPx),
            flip()
        ]
    }
}